import React, { ReactNode } from 'react';
import { TimePicker } from 'antd';
import { TimeRangePickerProps as TimeRangePickerCopyProps } from 'antd/lib/time-picker';

export type TimeRangePickerProps = TimeRangePickerCopyProps & {
  children?: ReactNode;
};

const ProTimeRangePicker: React.FC<TimeRangePickerProps> = React.forwardRef<
  any,
  TimeRangePickerProps
>((props, ref) => {
  const { children, ...resProps } = props;

  return <TimePicker.RangePicker ref={ref} {...resProps} />;
});

export default ProTimeRangePicker;
